import { INIT_IG_AUTH_ROUTE } from "./constants"

export enum ERROR {
    NOT_FOUND = 'NOT_FOUND',
    CACHED = 'CACHED',
    MONTHLY_APPLICATIONS_EXHAUSTED= 'monthly_applications_exhausted',
    PRO_REQUIRED = 'pro_required',
    CAMPAIGN_COMPLETED= 'campaign_complete',
    INVALID_ACCOUNT = 'invalid_account',
    INSUFFICIENT_PERMISSIONS = 'insufficient_permissions',
    ACCOUNT_NOT_FOUND = 'account_not_found',
    INVALID_ANSWER = 'invalid_answer'
}
export type ErrorType = {
    code: number,
    message: string,
    title?: string,
    cta?: {
        label: string,
        url: string
    }
}

export const errors: Record<ERROR, ErrorType> = {
    [ERROR.NOT_FOUND]: {
        code: 404,
        message: 'Not found'
    },
    [ERROR.CACHED]: {
        code: 304,
        message: 'Not modified'
    },
    [ERROR.MONTHLY_APPLICATIONS_EXHAUSTED]: {
        code: 429,
        title: 'Monthly Applications Exhausted',
        message: 'Your monthly application limit has been exhausted. Please upgrade your plan or wait until the next cycle.',
        cta: {
            label: 'Check Membership',
            url: '/membership'
        }
    },
    [ERROR.CAMPAIGN_COMPLETED]: {
        code: 400,
        title: 'Campaign Completed',
        message: 'The campaign has already been completed and cannot be applied.',
        cta: {
            label: 'Check Latest Campaigns',
            url: '/'
        }
    },
    [ERROR.INVALID_ACCOUNT]: {
        code: 400,
        title: 'Invalid Account',
        message: 'Connected account is either invalid or does not exist.',
        cta: {
            label: 'Login with Instagram',
            url: INIT_IG_AUTH_ROUTE
        }
    },
    [ERROR.INSUFFICIENT_PERMISSIONS]: {
        code: 403,
        message: 'You do not have sufficient permissions to perform this action. Missing Permissions: ',
    },
    [ERROR.ACCOUNT_NOT_FOUND]: {
        code: 404,
        title: 'Account Not Found',
        message: 'We could not find the connected account. Please log in again with Instagram.',
        cta: {
            label: 'Login with Instagram',
            url: INIT_IG_AUTH_ROUTE
        }
    },
    [ERROR.PRO_REQUIRED]: {
        code: 403,
        title: 'Pro Required',
        message: 'You need to upgrade to Pro to apply to this campaign.',
        cta: {
            label: 'Upgrade to Pro',
            url: '/subscription-plans'
        }
    },
    [ERROR.INVALID_ANSWER]: {
        code: 400,
        title: 'Invalid Answer',
        message: 'The answer is invalid. Please try again.',
        cta: {
            label: 'Try Again',
            url: '/'
        }
    }
}
